<template>
  <a-modal
    :title="modalTitle"
    :visible="open"
    :confirm-loading="submitLoading"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback :label="$t('views.account.password.old')" prop="oldPassword">
        <a-input-password v-model="form.oldPassword" :placeholder="$t('views.account.password.oldPlaceholder')" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item has-feedback :label="$t('views.account.password.new')" prop="newPassword">
        <a-input-password v-model="form.newPassword" :placeholder="$t('views.account.password.newPlaceholder')" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item has-feedback :label="$t('views.account.password.confirm')" prop="confirmPassword">
        <a-input-password v-model="form.confirmPassword" :placeholder="$t('views.account.password.confirmPlaceholder')" :maxLength="20" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { updateUserPwd } from '@/api/system/user'

export default {
  props: {
  },
  data () {
    return {
      submitLoading: false,
      open: false,
      childrenDrawer: false,
      formLayout: 'horizontal',
      form: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 }
      }
    }
  },
  computed: {
    modalTitle () {
      return this.$t('views.account.password.title')
    },
    rules () {
      return {
        oldPassword: [
          { required: true, message: this.$t('views.account.password.rule.oldRequired'), trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: this.validateNewPass, trigger: 'change' }
        ],
        confirmPassword: [
          { required: true, validator: this.validateConfirmPass, trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.reset()
  },
  methods: {
    validateNewPass (rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$t('views.account.password.rule.newRequired')))
      } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){5,20}$/.test(value)) {
        callback(new Error(this.$t('views.account.password.rule.newPattern')))
      } else {
        if (this.form.confirmPassword !== '') {
          this.$refs.form.validateField('confirmPassword')
        }
        callback()
      }
    },
    validateConfirmPass (rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$t('views.account.password.rule.confirmRequired')))
      } else if (value !== this.form.newPassword) {
        callback(new Error(this.$t('views.account.password.rule.confirmMismatch')))
      } else {
        callback()
      }
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
    },
    handleUpdatePwd () {
      this.open = true
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          updateUserPwd(this.form.oldPassword, this.form.newPassword).then(response => {
            this.$message.success(
              this.$t('views.account.password.msgSuccess'),
              3
            )
            this.open = false
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
